import { useQuery } from "react-query";

import { useJsonApi } from "@/modules/api/hooks/useJsonApi";
import { queryKeys } from "@/modules/api/queryKeys";
import { getSubtaskQuery } from "@/modules/tasks/api/queries/getSubtaskQuery";
import { useUserDataContext } from "@/modules/user/hooks/useUserDataContext";

export function useSubtaskDetailsQuery(subtaskId: string | undefined) {
  const jsonApi = useJsonApi();

  const { currentGroup } = useUserDataContext();
  return useQuery(
    currentGroup?.id && subtaskId
      ? {
          queryKey: [
            queryKeys.subtasks.getSubtaskDetails,
            subtaskId,
            currentGroup.id,
          ],
          queryFn: () =>
            getSubtaskQuery(jsonApi, {
              userGroupId: currentGroup.id,
              subtaskId,
            }),
          select: (response) => {
            if (response) {
              const { id, relationships, attributes } = response.data;
              return {
                id,
                name: attributes.name,
                comment: attributes.comment,
                description: attributes.description,
                pointsNumber: attributes.pointsNumber,
                rating: attributes.rating,
                complatedBy: relationships.completedBy.data?.id,
                tutorial: relationships.tutorial.data?.id,
                included: response.included,
              };
            }
          },
          retry: false,
          refetchOnWindowFocus: false,
        }
      : { enabled: false }
  );
}
